import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    // Token is already added in component via headers, but check sessionStorage as fallback
    if (!config.headers.Authorization) {
      const token = sessionStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // Don't show toast, let component handle it
          console.warn('401 Unauthorized - Authentication required');
          break;
        case 403:
          // Don't show toast here, let component handle it
          console.error('403 Forbidden:', data);
          break;
        case 404:
          // Don't show toast, let component handle it
          console.error('404 Not Found:', data);
          break;
        case 429:
          toast.error('Too many requests. Please try again later.');
          break;
        case 500:
          toast.error('Server error. Please try again later.');
          break;
        default:
          console.error(`Error ${status}:`, data);
      }
    } else if (error.request) {
      console.error('Network error:', error.message);
    } else {
      console.error('Request failed:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;